import { render } from "./DailyReport.vue?vue&type=template&id=2875f8d3&scoped=true"
import script from "./DailyReport.vue?vue&type=script&lang=js"
export * from "./DailyReport.vue?vue&type=script&lang=js"

import "./DailyReport.vue?vue&type=style&index=0&id=2875f8d3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2875f8d3"]])

export default __exports__